import React from "react";
import { STHead } from "@/components";
import { STOurTechnology } from "@/components/STOurTechnology";
import { getPageContentBySlug } from "@/actions";

export async function getStaticProps() {
  let pageData = null;
  try {
    const res = await getPageContentBySlug("our-technology");
    if (res?.success && res?.data) {
      pageData = res.data;
    }
  } catch (error) {
    console.error("Error fetching our-technology page data:", error);
  }

  return {
    props: {
      pageData,
    },
    revalidate: 60,
  };
}

const OurTechnology = ({ pageData }) => {
  const pageContent = pageData?.page?.page_content || {};
  const imageUrlBase = pageData?.imageUrl || "https://sustanix.com/";

  const metaTitle = pageContent.meta_title || "Our Technology - Barrier coatings for paper";
  const metaDescription =
    pageContent.meta_description ||
    "100% bio-based mono-material coating for high grease barrier, water vapour and water barrier in a single-layer for paper packaging.";
  const metaKeywords =
    pageContent.meta_keywords ||
    "Sustanix technology, green chemistry, sustainable additives, innovation";

  const ogTitle =
    pageContent.og_title ||
    metaTitle ||
    "100% bio-based barrier coatings for paper packaging";
  const ogDescription =
    pageContent.og_description ||
    metaDescription ||
    "Water, Grease & Water Vapour barrier in one layer through plant-based monomaterial coating technology";
  const ogKeywords =
    pageContent.og_keywords ||
    metaKeywords ||
    "Sustanix technology, green chemistry, sustainable additives, innovation";

  const getOgImage = () => {
    if (pageContent.og_image_url) return pageContent.og_image_url;
    if (pageContent.og_image) {
      if (
        pageContent.og_image.startsWith("http://") ||
        pageContent.og_image.startsWith("https://") ||
        pageContent.og_image.startsWith("/")
      ) {
        return pageContent.og_image;
      }
      return imageUrlBase.endsWith("/")
        ? `${imageUrlBase}${pageContent.og_image}`
        : `${imageUrlBase}/${pageContent.og_image}`;
    }
    return "https://sustanix.com/opengraph-image.webp";
  };

  const ogImage = getOgImage();

  return (
    <>
      <STHead
        title={metaTitle}
        description={metaDescription}
        keywords={metaKeywords}
        canonicalUrl="https://sustanix.com/our-technology/"
        ogTitle={ogTitle}
        ogDescription={ogDescription}
        ogKeywords={ogKeywords}
        ogUrl="https://sustanix.com/our-technology/"
        ogImage={ogImage}
        ogType="website"
      />
      <STOurTechnology pageData={pageData} slug="our-technology" />
    </>
  );
};

export default OurTechnology;
